<template>
  <div class="leaders-panel">
    <div class="leaders-title">新闻与传播研究所历任所领导</div>

    <section
      v-for="section in sections"
      :key="section.title"
      class="leaders-section"
    >
      <h3 class="leaders-section__title">{{ section.title }}</h3>
      <div class="leaders-table-wrap">
        <table class="leaders-table">
          <thead>
            <tr>
              <th>序号</th>
              <th>姓名</th>
              <th>职务</th>
              <th>任职时间</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in section.rows"
              :key="`${section.title}-${row.index}`"
            >
              <td class="leaders-table__index">{{ row.index }}</td>
              <td class="leaders-table__name">{{ row.name }}</td>
              <td>
                <div
                  v-for="appointment in row.appointments"
                  :key="`${row.name}-${appointment.position}-${appointment.period}`"
                  class="leaders-table__stack"
                >
                  {{ appointment.position }}
                </div>
              </td>
              <td>
                <div
                  v-for="appointment in row.appointments"
                  :key="`${row.name}-${appointment.period}-${appointment.position}`"
                  class="leaders-table__stack"
                >
                  {{ appointment.period }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <p class="leaders-note">（所党办根据档案整理）</p>
  </div>
</template>

<script>
export default {
  name: 'FormerDirectorsContent',
  data() {
    return {
      sections: [
        {
          title: '历任党委书记、分党组书记',
          rows: [
            { index: '1', name: '戴邦', appointments: [{ position: '党组书记、分党组书记', period: '1978.07—1983.04' }] },
            { index: '2', name: '商恺', appointments: [{ position: '分党组书记', period: '1986.04—1988.05' }] },
            { index: '3', name: '张秉意', appointments: [{ position: '党委书记', period: '1994.02—1996.02' }] },
            { index: '4', name: '陈谈强', appointments: [{ position: '党委书记', period: '1996.02—1998.09' }] },
            { index: '5', name: '尹韵公', appointments: [{ position: '党委书记', period: '2000.01—2000.07' }] },
            { index: '6', name: '孟庆海', appointments: [{ position: '党委书记', period: '2000.07—2005.08' }] },
            { index: '7', name: '张昌东', appointments: [{ position: '党委书记', period: '2005.08—2007.03' }] },
            { index: '8', name: '庄前生', appointments: [{ position: '党委书记', period: '2007.03—2012.02' }] },
            {
              index: '9',
              name: '赵天晓',
              appointments: [
                { position: '党委副书记（主持工作）', period: '2012.02—2013.06' },
                { position: '党委书记', period: '2013.06 至今' }
              ]
            }
          ]
        },
        {
          title: '历任所长',
          rows: [
            { index: '1', name: '安岗', appointments: [{ position: '所长', period: '1978.07—1984.01' }] },
            { index: '', name: '石西民', appointments: [{ position: '名誉所长', period: '1982.12' }] },
            { index: '2', name: '商恺', appointments: [{ position: '所长', period: '1984.01—1988.05' }] },
            {
              index: '3',
              name: '孙旭培',
              appointments: [
                { position: '代所长', period: '1988.05—1988.12' },
                { position: '所长', period: '1989.01—1994.07' }
              ]
            },
            { index: '4', name: '喻权域', appointments: [{ position: '所长', period: '1994.07—1998.09' }] },
            { index: '5', name: '尹韵公', appointments: [{ position: '所长', period: '1998.09—2012.02' }] },
            {
              index: '6',
              name: '唐绪军',
              appointments: [
                { position: '副所长（主持工作）', period: '2012.02—2013.06' },
                { position: '所长', period: '2013.06 至今' }
              ]
            }
          ]
        },
        {
          title: '历任党委副书记、纪委书记',
          rows: [
            { index: '1', name: '谭立', appointments: [{ position: '党委副书记', period: '1979.08—1982.07' }] },
            { index: '2', name: '张铁', appointments: [{ position: '党委副书记、机关党委书记', period: '1979.08、1982.10' }] },
            { index: '3', name: '师于', appointments: [{ position: '机关党委副书记', period: '1982.10—1983.04' }] },
            { index: '4', name: '王凤超', appointments: [{ position: '机关党委副书记、机关党委书记', period: '1983.05、1984.08' }] },
            { index: '5', name: '卫景福', appointments: [{ position: '机关党委书记', period: '1988.08—1994.01' }] },
            { index: '6', name: '尹韵公', appointments: [{ position: '党委副书记', period: '1997.10—1998.08' }] },
            { index: '7', name: '李斯颐', appointments: [{ position: '党委副书记', period: '1998.09—2000.07' }] },
            { index: '8', name: '季为民', appointments: [{ position: '纪委书记', period: '2016.07 至今' }] }
          ]
        },
        {
          title: '历任副所长',
          rows: [
            { index: '1', name: '戴邦', appointments: [{ position: '副所长', period: '1978.07—1983.04' }] },
            { index: '2', name: '谭立', appointments: [{ position: '副所长', period: '1978.07—1982.07' }] },
            { index: '3', name: '谢冰岩', appointments: [{ position: '副所长', period: '1979.08—1985.12' }] },
            { index: '4', name: '钱辛波', appointments: [{ position: '副所长', period: '1982.07—1986.10' }] },
            { index: '5', name: '王凤超', appointments: [{ position: '副所长', period: '1985.07—1989.01' }] },
            { index: '6', name: '杨润时', appointments: [{ position: '副所长', period: '1983.11—1985.04' }] },
            { index: '7', name: '东生', appointments: [{ position: '副所长', period: '1984.04—1988.05' }] },
            { index: '8', name: '孙旭培', appointments: [{ position: '副所长', period: '1985.07、1994.07' }] },
            { index: '9', name: '卫景福', appointments: [{ position: '副所长', period: '1988.05—1994.07' }] },
            { index: '10', name: '徐耀魁', appointments: [{ position: '副所长', period: '1989.01—1994.07' }] },
            { index: '11', name: '张秉意', appointments: [{ position: '副所长', period: '1994.02—1996.02' }] },
            { index: '12', name: '陈谈强', appointments: [{ position: '副所长', period: '1996.02—1998.09' }] },
            { index: '13', name: '宁新', appointments: [{ position: '副所长', period: '1997.01—2000.07' }] },
            { index: '14', name: '尹韵公', appointments: [{ position: '副所长', period: '1997.10—1998.09' }] },
            { index: '15', name: '李斯颐', appointments: [{ position: '副所长', period: '1998.09—2000.07' }] },
            { index: '16', name: '孟庆海', appointments: [{ position: '副所长', period: '2000.07—2005.08' }] },
            { index: '17', name: '张西明', appointments: [{ position: '副所长', period: '2003.09—2005.09' }] },
            { index: '18', name: '张昌东', appointments: [{ position: '副所长', period: '2005.08—2007.03' }] },
            { index: '19', name: '唐绪军', appointments: [{ position: '副所长', period: '2005.08—2012.02' }] },
            { index: '20', name: '庄前生', appointments: [{ position: '副所长', period: '2007.03—2012.02' }] },
            { index: '21', name: '赵天晓', appointments: [{ position: '副所长', period: '2012.02 至今' }] },
            { index: '22', name: '季为民', appointments: [{ position: '副所长', period: '2016.07 至今' }] }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
.leaders-panel {
  background: #fff;
  border: 1px solid #ece7dd;
}

.leaders-title {
  background: #ce6a33;
  color: #fff;
  font-size: 24px;
  line-height: 34px;
  padding: 12px 24px;
  font-family: SourceHanSerifCN-SemiBold, 'PingFang SC', sans-serif;
}

.leaders-section {
  padding: 20px 24px 8px;
}

.leaders-section + .leaders-section {
  padding-top: 10px;
}

.leaders-section__title {
  margin: 0 0 14px;
  color: #a45f19;
  font-size: 18px;
  line-height: 30px;
  font-family: SourceHanSerifCN-Regular, 'PingFang SC', sans-serif;
  font-weight: 400;
  padding-bottom: 8px;
  border-bottom: 1px solid #be8a4a;
}

.leaders-table-wrap {
  overflow-x: auto;
}

.leaders-table {
  width: 100%;
  border-collapse: collapse;
  color: #231f20;
  font-size: 15px;
  line-height: 1.8;
  font-family: SourceHanSerifCN-Regular, 'PingFang SC', sans-serif;
}

.leaders-table th,
.leaders-table td {
  padding: 10px 12px;
  border: 1px solid rgba(190, 138, 74, 0.22);
  vertical-align: top;
  text-align: left;
}

.leaders-table th {
  background: rgba(243, 236, 224, 0.65);
  font-weight: 700;
}

.leaders-table__index {
  width: 68px;
}

.leaders-table__name {
  width: 110px;
  white-space: nowrap;
}

.leaders-table__stack + .leaders-table__stack {
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px dashed rgba(190, 138, 74, 0.18);
}

.leaders-note {
  margin: 4px 24px 24px;
  color: #7d6d57;
  font-size: 14px;
  line-height: 1.7;
  text-align: right;
  font-family: SourceHanSerifCN-Regular, 'PingFang SC', sans-serif;
}

@media (max-width: 1100px) {
  .leaders-title {
    font-size: 22px;
    line-height: 32px;
  }

  .leaders-section__title {
    font-size: 17px;
    line-height: 28px;
  }
}
</style>
